export default "__VITE_ASSET__eb41d918__"